if (typeof ProductsSet !== "function") {
  class ProductsSet extends HTMLElement {
    constructor() {
      super();

      this.initSet();
      this.checkSet();
      this.initScrollButtons();

      // Listen for INIT_VARIANT_CHANGE event from the ProductVariants component
      document.addEventListener("INIT_VARIANT_CHANGE", () => {
        // Re-check all product variants in case their state has changed
        this.querySelectorAll("product-variants").forEach((elm) => {
          if (elm.hasAttribute("data-has-variants") && !elm.hasAttribute("data-unavailable")) {
            if (elm.currentVariant && elm.parentNode.querySelector('input[name="id"]')?.value) {
              this.set[elm.dataset.id] = elm.parentNode.querySelector('input[name="id"]').value;
              elm.closest("[data-js-product-item]").classList.add("selected");
              this.checkSet();
            }
          }
        });
      });

      this.querySelector("[data-js-add-set-to-cart]").addEventListener("click", (e) => {
        let items = [];
        Object.keys(this.set).map((key) => {
          if (this.set[key] !== null) {
            items.push({
              id: this.set[key],
              quantity: 1,
            });
          }
        });

        if (items.length > 0) {
          const submitButton = this.querySelector("[data-js-add-set-to-cart]");
          submitButton.classList.add("working");

          window.handleAddToCart(
            JSON.stringify({ items: items }),
            items.length,
            { "Content-Type": "application/json" },
            () => {
              this.returnToDefaultState();
            }
          );
        }
      });
    }

    initSet() {
      this.set = {};

      this.querySelectorAll("product-variants").forEach((elm) => {
        if (!elm.hasAttribute("data-has-variants") && !elm.hasAttribute("data-unavailable")) {
          this.set[elm.dataset.id] = elm.parentNode.querySelector('input[name="id"]').value;
          elm.closest("[data-js-product-item]").classList.add("selected");
        } else {
          // Check if a variant is already selected
          const hasSelectedVariant =
            elm.currentVariant !== undefined ||
            (elm.classList.contains("variant-selected") && elm.parentNode.querySelector('input[name="id"]')?.value);

          if (hasSelectedVariant) {
            this.set[elm.dataset.id] = elm.parentNode.querySelector('input[name="id"]').value;
            elm.closest("[data-js-product-item]").classList.add("selected");
          } else {
            this.set[elm.dataset.id] = null;
          }

          // Add event listener for future variant changes
          elm.addEventListener("VARIANT_CHANGE", (e) => {
            let variant = e.target.currentVariant;
            const variantInput = elm.parentNode.querySelector('input[name="id"]');

            if (variant && variantInput) {
              this.set[elm.dataset.id] = variantInput.value;
              elm.closest("[data-js-product-item]").classList.add("selected");
              /// elm.closest('toggle-tab').querySelector('[data-js-product-variant-title]').textContent = variant.title;
            } else {
              // Only set to null if there's no variant or no input value
              // This ensures that if a user selects back to the default variant, it still counts
              if (!variantInput || !variantInput.value) {
                this.set[elm.dataset.id] = null;
              }
              ///elm.closest('toggle-tab').querySelector('[data-js-product-variant-title]').textContent = '';
            }
            this.checkSet();
          });
        }
      });

      this.checkSet();
    }

    checkSet() {
      let setFull = true;

      // First check if we have any products in the set
      if (Object.keys(this.set).length === 0) {
        setFull = false;
      } else {
        // Then check if all products have valid variant selections
        Object.keys(this.set).forEach((key) => {
          if (this.set[key] === null) {
            setFull = false;
          }
        });
      }

      if (setFull && this.classList.contains("products-set--empty")) {
        this.classList.remove("products-set--empty");
        this.querySelector("[data-js-add-set-to-cart-text]").textContent = t(
          "sections.bundle-extra-words.sections.products_set.settings.cta_text.label"
        );
      } else if (!setFull && !this.classList.contains("products-set--empty")) {
        this.classList.add("products-set--empty");
        this.querySelector("[data-js-add-set-to-cart-text]").textContent = t(
          "sections.bundle-extra-words.sections.products_set.settings.missing_selection_cta_text.label"
        );
      }

      return setFull;
    }

    /**
     * Provides feedback that products were added to cart
     * while keeping the selected variants intact
     */
    returnToDefaultState() {
      // Give visual feedback that the set was added
      const submitButton = this.querySelector("[data-js-add-set-to-cart]");
      const buttonTextElement = this.querySelector("[data-js-add-set-to-cart-text]");
      const originalText = buttonTextElement.textContent; // Store original text

      // Remove working state immediately to stop spinner
      submitButton.classList.remove("working");

      // Show temporary success message
      buttonTextElement.textContent =
        t("sections.bundle-extra-words.sections.products_set.settings.main_cta_products_added_text.label") ||
        "Added to cart";

      // Reset button text after a delay
      setTimeout(() => {
        buttonTextElement.textContent = originalText;
      }, 2000);
    }

    initScrollButtons() {
      // Only initialize on mobile
      if (window.innerWidth > 767) return;

      this.querySelectorAll(".product-set-next-button").forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          const nextIndex = parseInt(button.dataset.nextItemIndex);
          const nextItem = this.querySelector(`.product-set-item-wrapper:nth-child(${nextIndex + 1})`);

          if (nextItem) {
            nextItem.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "end",
            });
          }
        });
      });

      // Handle resize events to disable/enable functionality
      window.addEventListener("resize", () => {
        const buttons = this.querySelectorAll(".product-set-next-button");
        if (window.innerWidth > 767) {
          buttons.forEach((button) => (button.style.display = "none"));
        } else {
          buttons.forEach((button) => (button.style.display = "flex"));
        }
      });
    }
  }

  if (typeof customElements.get("products-set") == "undefined") {
    customElements.define("products-set", ProductsSet);
  }
}
